import Input, { InputProps } from 'antd/lib/input';
import React, { ReactElement } from 'react';
import { default as NumberFormat } from 'react-number-format';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import '../FormItem/CRMFormInput.less';

const FormFormattedAmount = (props: any): ReactElement => {
  const formConfig = useGetFormConfig(props);
  const { disabled, placeholder, key, addonBefore, allowNegative, onChange, allowClear,
    onFocus, onBlur } = formConfig;

  return (
    <FormItem formConfig={formConfig}>
      <NumberFormat
        decimalScale={2}
        customInput={Input}
        thousandSeparator={true}
        thousandsGroupStyle="lakh"
        prefix={addonBefore || ''}
        autoComplete="off"
        placeholder={placeholder}
        disabled={disabled}
        onChange={(event: InputProps): void => onChange(event, key)}
        data-testid={key}
        allowClear={allowClear}
        allowNegative={allowNegative}
        onBlur={(): void => onBlur && onBlur()}
        onFocus={(): void => onFocus && onFocus()}
      />
    </FormItem>
  );
};

export default FormFormattedAmount;
